export enum OverlayIds {
  PRODUCT_FILTERS = 'product-filters',
  CREATE_WATCHLIST = 'create-watchlist',
  DELETE_WATCHLIST = 'delete-watchlist',
  RENAME_WATCHLIST = 'rename-watchlist',
  ADD_PRODUCT_TO_WATCHLIST = 'add-product-to-watchlist',
  MARKETING_OVERLAY = 'marketing-overlay',
  CLEAR_CART = 'clear-cart-overlay',
}
